import React, { useState } from "react";
import {
	Box,
	Paper,
	Button,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Typography,
	TextField,
} from "@mui/material";
import { Add as AddIcon } from "@mui/icons-material";
import instance from "../../apiServices/instance";
import { useParams } from "react-router-dom";

function TeamsOnboarding({ teamDetails, setCompanyInfo }) {
	const [openDialogBox, setOpenDialogBox] = useState({
		mainContact: false,
		openBox: false,
		BoxTitle: "MainContact",
	});

	const { id } = useParams();

	function onClose() {
		setOpenDialogBox((prev) => ({
			...prev,
			openBox: false,
		}));
		setContactData(() => ({
			name: "",
			title: "",
			email: "",
			phone: "",
		}));
	}

	// State to manage form inputs
	const [contactData, setContactData] = useState({
		name: "",
		title: "",
		email: "",
		phone: "",
	});

	// Handle input changes
	const handleInputChange = (e) => {
		const { name, value } = e.target;
		setContactData((prev) => ({
			...prev,
			[name]: value,
		}));
	};

	const handleSubmit = async () => {
		try {
			let requestPayload = {
				...contactData,
				mainContact: openDialogBox.mainContact,
			};
			console.log("requestPayload----->", requestPayload);
			// Make API call to update backend
			const response = await instance.post(
				`/add-contact/${id}`,
				JSON.stringify(requestPayload)
			);

			setCompanyInfo((prev) => ({
				...prev,
				teamDetails: response.data.data.teamDetails,
			}));
			// Close the dialog
			onClose();
		} catch (error) {
			console.error("Error adding contact:", error);
			// Optionally handle error (show snackbar, error message, etc.)
		}
	};

	const mainContactList = teamDetails.filter(
		(val) => val.mainContact == true
	);
	const teamMembersList = teamDetails.filter((val) => !val.mainContact);
	return (
		<Box>
			<Box sx={{ mt: 3 }}>
				<Box
					sx={{
						display: "flex",
						justifyContent: "space-between",
						alignItems: "center",
						mb: 2,
					}}>
					<Typography
						variant='h6'
						sx={{
							fontWeight: "bold",
							mb: 2,
							color: "black",
							fontSize: "23px",
						}}>
						Main Point of Contact
					</Typography>
					<Button
						variant='contained'
						startIcon={<AddIcon />}
						size='small'
						sx={{
							bgcolor: "#E5D4FC ",
							borderRadius: 2,
							p: 1,
							color: "black",
						}}>
						Add New Contact
					</Button>
				</Box>

				<TableContainer component={Paper} elevation={0}>
					<Table>
						<TableHead>
							<TableRow sx={{ backgroundColor: "#e8ecf8" }}>
								<TableCell>Name</TableCell>
								<TableCell>Title</TableCell>
								<TableCell>Email</TableCell>
								<TableCell sx={{ ml: 8 }}>
									Phone Number
								</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{mainContactList.map((val, index) => (
								<TableRow key={index}>
									<TableCell>{val.name}</TableCell>
									<TableCell>{val.title}</TableCell>
									<TableCell>{val.email}</TableCell>
									<TableCell>{val.phone}</TableCell>
								</TableRow>
							))}
						</TableBody>
					</Table>
				</TableContainer>

				<Box sx={{ display: "flex", my: 2 }}>
					<Button
						startIcon={<AddIcon />}
						size='small'
						sx={{ color: "#9161ff" }}
						onClick={() => {
							setOpenDialogBox((prev) => ({
								...prev,
								openBox: true,
								mainContact: true,
								BoxTitle: "Main Point of Contact",
							}));
						}}>
						Add contact
					</Button>
				</Box>
			</Box>

			<Box sx={{ mt: 4 }}>
				<Typography
					variant='h6'
					sx={{
						fontWeight: "bold",
						mb: 2,
						color: "black",
						fontSize: "23px",
					}}>
					Additional team members
				</Typography>

				<TableContainer component={Paper} elevation={0}>
					<Table>
						<TableHead>
							<TableRow sx={{ backgroundColor: "#e8ecf8" }}>
								<TableCell>Name</TableCell>
								<TableCell>Title</TableCell>
								<TableCell>Email</TableCell>
								<TableCell>Phone Number</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{teamMembersList.map((val, index) => (
								<TableRow key={index}>
									<TableCell>{val.name}</TableCell>
									<TableCell>{val.title}</TableCell>
									<TableCell>{val.email}</TableCell>
									<TableCell>{val.phone}</TableCell>
								</TableRow>
							))}
						</TableBody>
					</Table>
				</TableContainer>

				<Box sx={{ display: "flex", my: 2 }}>
					<Button
						startIcon={<AddIcon />}
						size='small'
						sx={{ color: "#9161ff" }}
						onClick={() => {
							setOpenDialogBox((prev) => ({
								...prev,
								openBox: true,
								mainContact: false,
								BoxTitle: "AdditionalMembers",
							}));
						}}>
						Add contact
					</Button>
				</Box>
			</Box>
			<Dialog
				open={openDialogBox.openBox}
				onClose={onClose}
				maxWidth='sm'
				fullWidth>
				<DialogTitle>
					Add{" "}
					{openDialogBox.BoxTitle === "AdditionalMembers"
						? "Additional Team Members"
						: "Main Point Of Contact"}
				</DialogTitle>
				<DialogContent>
					<TextField
						name='name'
						label='Name'
						fullWidth
						sx={{
							"& .MuiOutlinedInput-root": {
								borderRadius: 2,
							},
						}}
						margin='dense'
						value={contactData.name}
						onChange={handleInputChange}
					/>
					<TextField
						name='title'
						label='Title'
						fullWidth
						margin='dense'
						value={contactData.title}
						onChange={handleInputChange}
						sx={{
							"& .MuiOutlinedInput-root": {
								borderRadius: 2,
							},
						}}
					/>
					<TextField
						name='email'
						label='Email'
						fullWidth
						margin='dense'
						value={contactData.email}
						onChange={handleInputChange}
						sx={{
							"& .MuiOutlinedInput-root": {
								borderRadius: 2,
							},
						}}
					/>
					<TextField
						name='phone'
						label='Phone Number'
						fullWidth
						margin='dense'
						value={contactData.phone}
						onChange={handleInputChange}
						sx={{
							"& .MuiOutlinedInput-root": {
								borderRadius: 2,
							},
						}}
					/>
				</DialogContent>
				<DialogActions sx={{ mb: 1, mr: 2, gap: 1 }}>
					<Button
						onClick={onClose}
						sx={{
							color: "black",
							backgroundColor: "#f5f5f5",
							padding: "6px 16px",
							borderRadius: "8px",
							// fontWeight: "bold",
							textTransform: "none",
							width: "20%",
							boxShadow: "none",
							"&:hover": {
								backgroundColor: "#e0e0e0",
							},
						}}
						variant='contained'>
						Cancel
					</Button>

					<Button
						onClick={handleSubmit}
						sx={{
							backgroundColor: "#B794F6", // A nicer lavender shade
							color: "black",
							padding: "6px 16px",
							borderRadius: "8px",
							// fontWeight: "bold",
							textTransform: "none",
							boxShadow: "none",
							"&:hover": {
								backgroundColor: "#9F7AEA", // Darker lavender on hover
							},
						}}
						variant='contained'>
						Add Contact
					</Button>
				</DialogActions>

				{/* <DialogActions>
          <Button onClick={onClose} sx={{color:"black",bgcolor:"white",padding:"2px"}} color="secondary" variant="contained">
            Cancel
          </Button>
          <Button onClick={handleSubmit} sx={{bgcolor:"#E5D4FC",color:"black",}} variant="contained">
            Add Contact
          </Button>
        </DialogActions> */}
			</Dialog>
		</Box>
	);
}

export default TeamsOnboarding;
